import PropTypes from 'prop-types';
import MovieListItemContainer from '../movies-list-item/movies-list-item';

const MoviesList = ({movies}) => {
    return (
        <ul className='filmik__films'>
            {
                movies.map((movie) => {
                    return <MovieListItemContainer
                        key={movie.id}
                        movie={movie}
                    />;
                })
            }
        </ul>
    );
};

MoviesList.propTypes = {
    movies: PropTypes.array.isRequired,
};

export default MoviesList;